declare var CONFIG: {
  API: string;
  GOOGLE_API_KEY: string;
  ENVIRONMENT: string;
  SENTRY_DSN?: string;
  RELEASE?: string;
};

export const { API, GOOGLE_API_KEY, ENVIRONMENT, SENTRY_DSN, RELEASE } = CONFIG;
